var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar11 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-11_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5C400",
  d: "M60 30C60 13.432 46.569 0 30 0 13.432 0 0 13.432 0 30c0 16.569 13.432 30 30 30 16.569 0 30-13.431 30-30"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00CA69",
  d: "M38.188 7.05s2.295 9.043-7.433 12.39c0 0-1.857-10.683 7.433-12.39"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#794B37",
  d: "M29.808 19.658h.385c.443 0 .802-.36.802-.803V12.56a.803.803 0 0 0-.802-.803h-.385a.803.803 0 0 0-.803.803v6.295c0 .443.36.802.803.802"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF6651",
  d: "m15.095 22.968.005.01c1.733-3.313 5.38-5.598 9.598-5.598 1.932 0 3.744.48 5.307 1.318a11.2 11.2 0 0 1 5.308-1.318c4.215 0 7.857 2.278 9.592 5.585 0 0 4.493 7.613.86 16.323-2.008 5.695-8.303 9.85-15.76 9.85-7.46 0-13.757-4.16-15.762-9.858l-.008.008c-3.633-8.71.86-16.323.86-16.323z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E25344",
  d: "M43.628 37.245c.162-.775.282-1.562.37-2.362.407-3.713-.048-7.523-1.8-10.86-1.735-3.308-5.04-5.88-9.255-5.88q-1.164.002-2.258.224c1.4-.63 2.97-.982 4.628-.982 4.215 0 7.857 2.278 9.592 5.585 0 0 4.493 7.613.858 16.322-1.965 4.713-6.045 8.185-11.095 9.225 1.247-.257 2.65-1.367 3.622-2.145 2.855-2.287 4.598-5.58 5.338-9.124z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.878 26.293a1.82 1.82 0 1 0 0-3.64 1.82 1.82 0 0 0 0 3.64"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-11_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})))));
export { SvgAvatar11 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-11.56fb542b40a5e285fdca.svg";